import React, { type ReactNode } from "react";
import { clsx } from "clsx";
import { SectionBreak } from "@bloomberg/media-ui-article";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import type { CommonNode } from "@foundation/rich-text-react-renderer";

import styles from "./ArticleBodyText.module.css";

interface ArticleBodyTextProps {
    children: ReactNode;
    className?: string;
    isFeatured?: boolean;
    node?: CommonNode;
}

export const ArticleBodyText = ({
    children,
    className,
    isFeatured = false,
    node,
}: ArticleBodyTextProps) => {
    const isSectionBreak = node?.data.class === "section-break";

    return (
        <>
            {!isFeatured && isSectionBreak && <SectionBreak />}

            <p
                className={clsx(
                    styles.articleBodyContent,
                    typographyStyles.articleBody,
                    className,
                    {
                        [styles.sectionBreak]: isFeatured && isSectionBreak,
                    }
                )}
                data-component="paragraph"
            >
                {children}
            </p>
        </>
    );
};
